"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
var CheckboxIcon_1 = __importDefault(require("../../../Assets/CustomIcons/CheckboxIcon"));
var react_1 = require("@emotion/react");
var InsetCheckbox = function (_a) {
    var checked = _a.checked, dataTestId = _a.dataTestId, customCss = _a.customCss;
    return ((0, jsx_runtime_1.jsx)(Checkbox_1.default, { checked: checked, color: "primary", onClick: function (event) { return event.preventDefault(); }, icon: (0, jsx_runtime_1.jsx)(CheckboxIcon_1.default, { isChecked: false }), checkedIcon: (0, jsx_runtime_1.jsx)(CheckboxIcon_1.default, { isChecked: true }), onMouseDown: function (event) { return event.preventDefault(); }, "data-testid": dataTestId, css: customCss || (0, react_1.css)({ margin: 0, padding: 0 }) }));
};
exports.default = InsetCheckbox;
//# sourceMappingURL=InsetCheckbox.js.map